"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEachFirstLetterToUpperCase = exports.formatEinData = exports.mapNonProfitCause = void 0;
const common_1 = require("../../enums/common");
const country_1 = require("../enums/country");
const countryCauseMap = {
    Canada: {
        // Animal Welfare
        CODE_180: common_1.OrganizationCategory.AnimalWelfare,
        // Community Service
        CODE_160: common_1.OrganizationCategory.CommunityService,
        CODE_200: common_1.OrganizationCategory.CommunityService,
        CODE_150: common_1.OrganizationCategory.CommunityService,
        // Culture
        CODE_190: common_1.OrganizationCategory.Culture,
        CODE_12: common_1.OrganizationCategory.Culture,
        CODE_215: common_1.OrganizationCategory.Culture,
        // Education
        CODE_214: common_1.OrganizationCategory.Education,
        CODE_13: common_1.OrganizationCategory.Education,
        CODE_15: common_1.OrganizationCategory.Education,
        CODE_11: common_1.OrganizationCategory.Education,
        CODE_10: common_1.OrganizationCategory.Education,
        // Environment
        CODE_170: common_1.OrganizationCategory.Environment,
        // Health
        CODE_140: common_1.OrganizationCategory.Health,
        CODE_100: common_1.OrganizationCategory.Health,
        CODE_130: common_1.OrganizationCategory.Health,
        CODE_120: common_1.OrganizationCategory.Health,
        CODE_110: common_1.OrganizationCategory.Health,
        // Humanitarian
        CODE_155: common_1.OrganizationCategory.Humanitarian,
        // Religion
        CODE_30: common_1.OrganizationCategory.Religion,
        CODE_80: common_1.OrganizationCategory.Religion,
        CODE_90: common_1.OrganizationCategory.Religion,
        CODE_40: common_1.OrganizationCategory.Religion,
        CODE_50: common_1.OrganizationCategory.Religion,
        CODE_60: common_1.OrganizationCategory.Religion,
        CODE_70: common_1.OrganizationCategory.Religion,
        // Social Service
        CODE_2: common_1.OrganizationCategory.SocialService,
        CODE_1: common_1.OrganizationCategory.SocialService,
        // Other
        CODE_175: common_1.OrganizationCategory.Other,
        CODE_210: common_1.OrganizationCategory.Other,
        CODE_14: common_1.OrganizationCategory.Other,
    },
    UnitedStates: {
        // Culture
        A: common_1.OrganizationCategory.Culture,
        // Education
        B: common_1.OrganizationCategory.Education,
        O: common_1.OrganizationCategory.Education,
        // Environment
        C: common_1.OrganizationCategory.Environment,
        // Animal Welfare
        D: common_1.OrganizationCategory.AnimalWelfare,
        // Health
        E: common_1.OrganizationCategory.Health,
        F: common_1.OrganizationCategory.Health,
        G: common_1.OrganizationCategory.Health,
        H: common_1.OrganizationCategory.Health,
        // Social Service
        J: common_1.OrganizationCategory.SocialService,
        L: common_1.OrganizationCategory.SocialService,
        V: common_1.OrganizationCategory.SocialService,
        W: common_1.OrganizationCategory.SocialService,
        // Humanitarian
        M: common_1.OrganizationCategory.Humanitarian,
        P: common_1.OrganizationCategory.Humanitarian,
        // Sports And Leisure
        N: common_1.OrganizationCategory.SportsAndLeisure,
        // Politics
        Q: common_1.OrganizationCategory.Politic,
        R: common_1.OrganizationCategory.Politic,
        // Community Service
        S: common_1.OrganizationCategory.CommunityService,
        // Religion
        X: common_1.OrganizationCategory.Religion,
        // Other
        I: common_1.OrganizationCategory.Other,
        K: common_1.OrganizationCategory.Other,
        T: common_1.OrganizationCategory.Other,
        U: common_1.OrganizationCategory.Other,
        Y: common_1.OrganizationCategory.Other,
        Z: common_1.OrganizationCategory.Other,
    },
};
const DE_ZER_PURPOSE_CATEGORIES = {
    1: common_1.OrganizationCategory.Education,
    2: common_1.OrganizationCategory.Religion,
    3: common_1.OrganizationCategory.Health,
    4: common_1.OrganizationCategory.SocialService,
    5: common_1.OrganizationCategory.SocialService,
    6: common_1.OrganizationCategory.SocialService,
    7: common_1.OrganizationCategory.Culture,
    8: common_1.OrganizationCategory.Culture,
    9: common_1.OrganizationCategory.Culture,
    10: common_1.OrganizationCategory.Culture,
    11: common_1.OrganizationCategory.Education,
    12: common_1.OrganizationCategory.Education,
    13: common_1.OrganizationCategory.Education,
    14: common_1.OrganizationCategory.Environment,
    15: common_1.OrganizationCategory.Environment,
    16: common_1.OrganizationCategory.Environment,
    17: common_1.OrganizationCategory.Environment,
    18: common_1.OrganizationCategory.SocialService,
    19: common_1.OrganizationCategory.Humanitarian,
    20: common_1.OrganizationCategory.Humanitarian,
    21: common_1.OrganizationCategory.Humanitarian,
    22: common_1.OrganizationCategory.Veterans,
    23: common_1.OrganizationCategory.SocialService,
    24: common_1.OrganizationCategory.SocialService,
    25: common_1.OrganizationCategory.Humanitarian,
    26: common_1.OrganizationCategory.Humanitarian,
    27: common_1.OrganizationCategory.SocialService,
    28: common_1.OrganizationCategory.CommunityService,
    29: common_1.OrganizationCategory.CommunityService,
    30: common_1.OrganizationCategory.CommunityService,
    31: common_1.OrganizationCategory.CommunityService,
    32: common_1.OrganizationCategory.CommunityService,
    33: common_1.OrganizationCategory.CommunityService,
    34: common_1.OrganizationCategory.Humanitarian,
    35: common_1.OrganizationCategory.AnimalWelfare,
    36: common_1.OrganizationCategory.Humanitarian,
    37: common_1.OrganizationCategory.CommunityService,
    38: common_1.OrganizationCategory.SocialService,
    39: common_1.OrganizationCategory.SocialService,
    40: common_1.OrganizationCategory.SocialService,
    41: common_1.OrganizationCategory.CommunityService,
    42: common_1.OrganizationCategory.SportsAndLeisure,
    43: common_1.OrganizationCategory.Culture,
    44: common_1.OrganizationCategory.Culture,
    45: common_1.OrganizationCategory.Culture,
    46: common_1.OrganizationCategory.CommunityService,
    47: common_1.OrganizationCategory.SportsAndLeisure,
    48: common_1.OrganizationCategory.SportsAndLeisure,
    49: common_1.OrganizationCategory.SportsAndLeisure,
    50: common_1.OrganizationCategory.SportsAndLeisure,
    51: common_1.OrganizationCategory.Culture,
    52: common_1.OrganizationCategory.Veterans,
    53: common_1.OrganizationCategory.SportsAndLeisure,
    54: common_1.OrganizationCategory.SportsAndLeisure,
    55: common_1.OrganizationCategory.SportsAndLeisure,
    56: common_1.OrganizationCategory.CommunityService,
    57: common_1.OrganizationCategory.Politic,
    58: common_1.OrganizationCategory.CommunityService,
    59: common_1.OrganizationCategory.CommunityService,
    60: common_1.OrganizationCategory.CommunityService,
    61: common_1.OrganizationCategory.CommunityService,
    62: common_1.OrganizationCategory.Other,
    63: common_1.OrganizationCategory.SocialService,
    64: common_1.OrganizationCategory.Other,
    65: common_1.OrganizationCategory.Other,
    66: common_1.OrganizationCategory.SocialService,
    67: common_1.OrganizationCategory.SocialService,
    68: common_1.OrganizationCategory.Religion,
    69: common_1.OrganizationCategory.Religion,
    900: common_1.OrganizationCategory.Humanitarian,
    901: common_1.OrganizationCategory.Politic,
    902: common_1.OrganizationCategory.CommunityService,
    903: common_1.OrganizationCategory.Other,
    904: common_1.OrganizationCategory.Other,
    905: common_1.OrganizationCategory.Health,
    906: common_1.OrganizationCategory.SocialService,
};
const mapNonProfitCause = (causeCode, country) => {
    if (!causeCode) {
        return null;
    }
    if (country === country_1.OrganizationCountry.Canada) {
        const causeCodeFormatted = `CODE_${causeCode}`;
        return countryCauseMap.Canada[causeCodeFormatted] ?? null;
    }
    if (country === country_1.OrganizationCountry.UnitedStates) {
        const firstLetter = causeCode.charAt(0).toUpperCase();
        return countryCauseMap.UnitedStates[firstLetter] ?? null;
    }
    if (country === country_1.OrganizationCountry.Germany) {
        const zerPurposeIds = causeCode.split(",").map((id) => Number(id.trim()));
        return zerPurposeIds.map((id) => DE_ZER_PURPOSE_CATEGORIES[id]).find(Boolean) ?? null;
    }
    return null;
};
exports.mapNonProfitCause = mapNonProfitCause;
const formatEinData = (data, country) => {
    if (["GB", "gb", "UK", "uk", "GreatBritain", "UnitedKingdom"].includes(country)) {
        const crn = data[0].trim().replace(/\D/g, "");
        const isRegistered = data[2].trim().toLowerCase() === "registered";
        const isMainCharity = !data[9]?.trim() || data[9].trim() === "0";
        if (!isRegistered || !isMainCharity || !/^\d{5,8}$/.test(crn)) {
            return {};
        }
        const latestIncome = data[5]?.trim();
        return {
            country: country_1.OrganizationCountry.GreatBritain,
            einBn: crn,
            name: (0, exports.formatEachFirstLetterToUpperCase)(data[1]),
            ico: null,
            street: data[6]?.trim() || null,
            city: data[7]?.trim() ? (0, exports.formatEachFirstLetterToUpperCase)(data[7]) : null,
            state: null,
            zip: data[8]?.trim() || null,
            subsectionCode: null,
            cause: null,
            dateStatusObtention: data[4]?.trim() || null,
            sortName: null,
            deductibility: null,
            organizationType: data[3]?.trim() || null,
            assetAmount: null,
            incomeAmount: latestIncome && /^\d+$/.test(latestIncome) ? BigInt(latestIncome) : null,
            revenueAmount: null,
        };
    }
    let einBnInput = data[0].trim().replace(/\D/g, "");
    while (einBnInput.length < 9) {
        einBnInput = "0" + einBnInput;
    }
    const einBn = einBnInput.slice(0, 2) + "-" + einBnInput.slice(2);
    return {
        country: country_1.OrganizationCountry.UnitedStates,
        einBn,
        name: (0, exports.formatEachFirstLetterToUpperCase)(data[1]),
        ico: data[2],
        street: data[3],
        city: (0, exports.formatEachFirstLetterToUpperCase)(data[4]),
        state: data[5],
        zip: data[6],
        subsectionCode: Number(data[8]),
        cause: data[26],
        dateStatusObtention: data[11],
        sortName: data[27],
        deductibility: Number(data[12]),
        organizationType: data[15],
        assetAmount: data[23] ? BigInt(data[23]) : null,
        incomeAmount: data[24] ? BigInt(data[24]) : null,
        revenueAmount: data[25] ? BigInt(data[25]) : null,
    };
};
exports.formatEinData = formatEinData;
const formatEachFirstLetterToUpperCase = (str) => {
    return str
        .toLowerCase()
        .trim()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};
exports.formatEachFirstLetterToUpperCase = formatEachFirstLetterToUpperCase;
